module.exports = __webpack_public_path__ + "static/img/card-bg.b9344fee.png";